import useLocales from "@hooks/useLocales";
import { useState } from "react";
import { UseFormSetValue } from "react-hook-form";
import { useLocation } from "react-router";
import { GetAsync } from "src/common/httpRequests";
import { API_GATEWAY } from "src/constants/settings";

interface UseDocumentNumberProps {
  documentClass: string;
  setValue: UseFormSetValue<any>;
  invoiceType?: string;
}

const useDocumentNumber = (props: UseDocumentNumberProps) => {
  const { documentClass, setValue, invoiceType } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { pathname } = useLocation();
  const [error, setError] = useState<string>("");
  const { translate } = useLocales();

  const handleFetchDocumentNumber = async () => {
    setIsLoading(true);
    setError("");

    await GetAsync(
      `${API_GATEWAY}/api/manualdocumentservice/manualDocument/${
        invoiceType
          ? `GenerateDocumentNumberWithSeriesV2?accountClass=AccountReceivable&documentClass=${documentClass}&complianceStandardDocumentType=${invoiceType}`
          : `GenerateDocumentNumber?documentType=${documentClass}`
      }`,
    ).then((response) => {
      if (response?.status >= 400) {
        const errorDetail = response?.data?.Detail;
        setError(
          translate("no_series_found_against_document_type") || errorDetail,
        );
        setIsLoading(false);
        return;
      }
      if (response?.data) {
        const {
          documentNumber,
          series,
          sequenceNumber,
          documentNumberSeriesId,
        } = response?.data;
        setValue("documentNumber", documentNumber);
        if (invoiceType) {
          setValue("series", series);
          setValue("sequenceNumber", sequenceNumber);
          setValue("documentNumberSeriesId", documentNumberSeriesId);
        }
      } else {
        setError("No document number received from server");
      }
      setIsLoading(false);
    });
  };

  return { isLoading, handleFetchDocumentNumber, error };
};

export default useDocumentNumber;
